import { FC, ReactElement, memo } from 'react';
import theme from '~/constants/styles';
import { IInputProps } from '~/view/components/Controls/InputComponent/types';
import Spinner from '~/view/components/Controls/Spinner/Spinner';
import './style.scss';

type TProps = Pick<IInputProps, 'loading'>;

const SpinnerInInput: FC<TProps> = ({ loading }: TProps): ReactElement | null => {
  if (!loading) return null;

  return <Spinner color={theme.colors.gray} className="spinner-in-input" />;
};

export default memo(SpinnerInInput);
